import { redirect } from 'react-router';
import { useAuth } from '../../contexts/AuthProvider';
import { baseURL } from '../../constants/config';
import { useEffect } from 'react';

export const Logout: React.FC = () => {
  const { authLogout } = useAuth();
  useEffect(() => {
    authLogout();
    redirect(baseURL);
  });

  return (<></>);
};
